import 'bootstrap';
import * as moment from 'moment';
import 'platform';
import * as _ from 'underscore';
import '@fancyapps/fancybox';
import * as Modernizr from 'modernizr';
//import Vue from 'vue';
import Vue from 'vue/dist/vue.common.js';
import * as VuePaginator from 'vuejs-paginate';
import VeeValidate from 'node_modules/vee-validate';
import VueRecaptcha from 'vue-recaptcha';
// import 'promise-polyfill/src/polyfill';
import axios from 'axios';

import aeAriaLive from './modules/classes/aeAriaLive.js';
import backgroundImage from './modules/classes/backgroundImage.js';
import bodyPlatform from './modules/classes/bodyPlatform.js';
import checkTab from './modules/classes/checkTab.js';
import facultyStaffDirectory from './modules/classes/facultyStaffDirectory.js';
import fancyBoxAccessibility from './modules/classes/fancyBoxAccessibility.js';
import generalAdjustments from './modules/classes/generalAdjustments.js';
import hasTabbed from './modules/classes/hasTabbed.js';
import homepageAlert from './modules/classes/homepageAlert.js';
import homepageLocationSelection from './modules/classes/homepageLocationSelection.js';
import mobileImageOrder from './modules/classes/mobileImageOrder.js';
import moreInfoFooterForm from './modules/classes/moreInfoFooterForm.js';
import paginationAccessibility from './modules/classes/paginationAccessibility.js';
import photoGallery from './modules/classes/photoGallery.js';
import recaptchaAccessibility from './modules/classes/recaptchaAccessibility.js';
import researchProject from './modules/classes/researchProject.js';
import skipToContent from './modules/classes/skipToContent.js';
import sortAlphabetically from './modules/classes/sortAlphabetically.js';
import StyleGuide from "./modules/classes/StyleGuide.js";
import utility from './modules/classes/utility.js';

import mainNav from '../../../../../ae_msu/blocks/autonav/templates/accessible_msu/modules/classes/accessibleDesktopNav.js';
import mobileNav from '../../../../../ae_msu/blocks/autonav/templates/msu-mobile/modules/classes/msuMobileHeaderNav.js';
import eventList from '../../../../blocks/events_list/modules/classes/eventList.js';
import footerFAQ from './modules/classes/footerFAQ.js';

export function run() {
    window.moment = moment;
    window.axios = axios;
    window.Vue = Vue;
    Vue.component('pagination', VuePaginator);
    Vue.component('vue-recaptcha', VueRecaptcha);
    Vue.use(VeeValidate);
    Vue.use(VueRecaptcha);
    Vue.prototype.$http = axios
    window.$ = jQuery;

    window.StyleGuide = StyleGuide;
    const aeAriaLiveInst                = new aeAriaLive();
    const backgroundImageInst           = new backgroundImage();
    const bodyPlatformInst              = new bodyPlatform();
    const checkTabInst                  = new checkTab();
    const facultyStaffDirectoryInst     = new facultyStaffDirectory();
    const fancyBoxAccessibilityInst     = new fancyBoxAccessibility();
    const generalAdjustmentsInst        = new generalAdjustments();
    const hasTabbedInst                 = new hasTabbed();
    const homepageAlertInst             = new homepageAlert();
    const homepageLocationSelectionInst = new homepageLocationSelection();
    const mobileImageOrderInst          = new mobileImageOrder(_, Modernizr);
    const moreInfoFooterFormInst        = new moreInfoFooterForm();
    const paginationAccessibilityInst   = new paginationAccessibility();
    const photoGalleryInst              = new photoGallery();
    const recaptchaAccessibilityInst    = new recaptchaAccessibility();
    const researchProjectInst           = new researchProject();
    const skipToContentInst             = new skipToContent();
    const sortAlphabeticallyInst        = new sortAlphabetically();
    const utilityInst                   = new utility();

    const mainNavConst   = new mainNav();
    const mobileNavConst = new mobileNav();
    const footerFAQInst = new footerFAQ();
    const eventListInst = new eventList();
}
